import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AbModule } from '@df/module-ab/ab.module';
import { DfImageWrapperComponent } from '@df/module-image/df-image-wrapper.component';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { KlevuTrackCategoryProductClickDirective } from '@df/module-klevu-search/klevu-track-category-product-click.directive';
import { KlevuTrackClickDirective } from '@df/module-klevu-search/klevu-track-click.directive';
import { KlevuTrackRecommendationsProductClickDirective } from '@df/module-klevu-search/klevu-track-recommendations-product-click.directive';
import { DfUiCarouselModule } from '@df/ui-carousel/carousel.module';
import { HTMLBindingDirective } from '@df/ui/common/html-binding.directive';
import { IfBrowserDirective } from '@df/ui/common/if-browser.directive';
import { RatingComponent } from '@df/ui/common/rating.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { GtmTrackClickDirective } from '../../../module/gtm/gtm-track-click.directive';
import { GtmTrackSelectItemDirective } from '../../../module/gtm/gtm-track-select-item.directive';
import { LocalVimeoPlayerComponent } from '../../../ui/display/media/vimeo-player.component';
import { WishlistCarouselRemoveComponent } from '../wishlist/remove/wishlist-carousel-remove.component';
import { WishlistRemoveComponent } from '../wishlist/remove/wishlist-remove.component';
import { ProductDiscountLabelComponent } from './discount-label/product-discount-label.component';
import { ProductListingAddToBasketExpComponent } from './listing/add-to-basket/product-listing-add-to-basket-exp.component';
import { ProductListingAddToBasketComponent } from './listing/add-to-basket/product-listing-add-to-basket.component';
import { ProductListingWishlistComponent } from './listing/wishlist/product-listing-wishlist.component';
import { ProductListingWishlistToggleComponent } from './listing/wishlist/toggle/product-listing-wishlist-toggle.component';
import { ProductAbstract } from './product.abstract';
import { SwatchComponent } from './swatch/swatch.component';
import { AspectRatioPipe } from './ui/aspect-ratio.pipe';

@Component({
    selector: 'product',
    templateUrl: './product.html',
    styleUrl: './product.scss',
    host: {
        '(mouseenter)': 'onMouseIn()',
        '(mouseleave)': 'onMouseOut()'
    },
    standalone: true,
    imports: [
        AbModule,
        AspectRatioPipe,
        CommonModule,
        DfImageDirective,
        DfImageWrapperComponent,
        DfUiCarouselModule,
        GtmTrackSelectItemDirective,
        IfBrowserDirective,
        HTMLBindingDirective,
        KlevuTrackCategoryProductClickDirective,
        KlevuTrackClickDirective,
        KlevuTrackRecommendationsProductClickDirective,
        LocalVimeoPlayerComponent,
        PriceComponent,
        ProductDiscountLabelComponent,
        ProductListingAddToBasketComponent,
        ProductListingAddToBasketExpComponent,
        ProductListingWishlistComponent,
        ProductListingWishlistToggleComponent,
        RatingComponent,
        RouterModule,
        SizeClassDirective,
        SwatchComponent,
        WishlistCarouselRemoveComponent,
        WishlistRemoveComponent,
        TranslatePipe,
        GtmTrackClickDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductComponent extends ProductAbstract {}
